var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Changelog")]),_c('div',[_c('ul',[_c('li',[_vm._v("Coffee")]),_c('li',[_vm._v("Tea")]),_c('li',[_vm._v("Milk")])])])])}]

export { render, staticRenderFns }